import slugify from '@sindresorhus/slugify';
import Sequence from './Sequence';
import Search from './Search';

export default class Channel {
  static TYPES = {
    permanent: 0,
    tempory: 1,
  }
  static getSequencesByDocs(docs = []) {
    const sequences = [];
    let sequence;
    let startAt = 0;

    docs.forEach((doc = {}, index) => {
      sequence = new Sequence({
        ...doc,
        title: doc.title,
        description: doc.caption,
        medias: doc.bagItem,
        content: doc.news,
        published: new Date(doc.published),
        slugs: doc.slug,
        topics: doc.topic,
        location: doc.location,
        city: doc.city,
        startAt,
        order: index,
        video: doc.entity_video === 'yes',
      });

      startAt += sequence.duration;

      sequences.push(sequence);
    });

    return sequences;
  }
  constructor(params = {}) {
    this.name = (params.name || '').toString();
    this.id = slugify(this.name);
    this.type = params.type || Channel.TYPES.permanent;

    // Search params
    this.search = params.search instanceof Search ? params.search : new Search();

    // Sequences
    this.currentSequenceId = undefined;
    this.sequences = [];

    if (Array.isArray(params.sequences) && params.sequences.length > 0) {
      this.sequences = params.sequences;

      if (this.sequences.find(s => s.id === params.currentSequenceId)) {
        this.currentSequenceId = params.currentSequenceId;
      } else {
        this.currentSequenceId = params.sequences[0].id;
      }
    }
  }
  getSequenceById(sequenceId) {
    let sequence = null;

    if (this.sequences.indexOf(sequenceId) >= 0) {
      sequence = this.sequences[sequenceId];
    }

    return sequence;
  }
  getNextSequence() {
    if (this.sequences[this.currentSequenceId] < this.sequences.length) {
      this.currentSequenceId = this.currentSequenceId + 1;
    }
    return this.sequences[this.currentSequenceId];
  }
  getPreviousSequence() {
    if (this.sequences[this.currentSequenceId] > 0) {
      this.currentSequenceId = this.currentSequenceId - 1;
    }

    return this.sequences[this.currentSequenceId];
  }
  setName(name) {
    this.name = name;
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/models/Channel.js